<template>
	<div class="nk-list virtual-scroller" style="overflow-y:auto; position: relative; height: 100%" :class="{ 'empty': isListEmpty }" @focus="listFocused" tabindex="0">
		<div :class="{ 'focused': -1 === localActiveIndex }" class="dropdown-item active" style="display:flex; align-items: center" v-if="options.multiSelection && filteredData.length > 1">
			<input type="checkbox" v-model="currentToggle" v-on:change="toggleAll(!$event.target.checked)" class="ml-2" />
			<a href="#" class="list-item" @click="toggleAll(null)">{{ $t('select-all') }}</a>
		</div>
		<div v-for="(item, index) in filteredData" :key="item.id" :data-id="index" :class="{ 'active': index === localActiveIndex || options.multiSelection, 'focused': index === localActiveIndex, 'dropdown-item-disabled': item.disabled === true }" class="dropdown-item" style="display:flex; align-items: center">
			<input v-if="options.multiSelection" type="checkbox" :disabled="item.disabled ? true : null" v-on:change="changeCheckbox(item, $event)" class="ml-2" :checked="item.selected" />
			<a v-if="item.seprator" href="#" id="seprator" class="list-item" v-html="item.html"></a>
			<a v-else href="#" class="list-item" @click="selectItem(item, $event)" ref="input" v-html="display(item, index)"></a>
		</div>
		<div class="nk-list-empty" v-if="isListEmpty">{{ $t('list.empty') }}</div>
	</div>
</template>
<script>
	import $ from 'jquery'
	import { cloneDeep } from 'lodash'

	export default {
		props: {
			data: {},
			modelValue: {},
			options: {},
			activeIndex: {},
		},
		emits: ['activeIndex', 'enter-pressed', 'update:modelValue'],
		watch: {
			valueIndex: {
				handler(val, oldVal) {
					this.localActiveIndex = val
				}
			},
			activeIndex: {
				handler(val, oldVal) {
					this.resetLocalActiveIndex(val)
				}
			},
			modelValue: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					if (Array.isArray(val)) {
						if (val.length !== this.filteredData.filter(x => x.selected).length)
							this.filteredData.forEach(x => {
								x.selected = this.modelValue.some(y => this.getID(y) === this.getID(x))
							})
					} else if (this.options.multiSelection) {
						this.filteredData.forEach(x => {
							x.selected = false
						})
					}
				}
			},
			localActiveIndex: {
				handler(val, oldVal) {
					this.$emit('activeIndex', val)
				}
			},
		},
		data() {
			return {
				localActiveIndex: this.options.multiSelection ? -1 : -1,
				localArray: [],
			}
		},
		computed: {
			filteredData() {
				return cloneDeep(this.data) || []
			},
			valueIndex() {
				if (this.modelValue) {
					if (typeof this.modelValue === 'string')
						return this.filteredData.findIndex(a => a === this.modelValue)

					return this.filteredData.findIndex(a => this.getID(a) === this.getID(this.modelValue))
				} else {
					return -1
				}
			},
			isListEmpty() {
				return !this.filteredData || this.filteredData.length === 0
			},
			display() {
				if (this.options && typeof this.options.display === 'function') {
					return this.options.display
				} else {
					return (item) => item.toLocaleDigits()
				}
			},
			currentToggle() {
				if (!this.options.multiSelection || !this.filteredData.length) return false
				const selectableItems = this.filteredData.filter(x => x.disabled !== true)
				if (selectableItems.length === 0) return false

				return selectableItems.every(item =>
					this.modelValue.some(selected => this.getID(selected) === this.getID(item))
				)
			}
		},
		created() {
			this.resetLocalActiveIndex(this.activeIndex)
		},
		mounted() {
		},
		updated() {
			this.defer(this.subscribeKeys, 1)
		},

		methods: {
			getID(obj) {
				return obj && (obj.id || obj.key || obj.value)
			},
			findNextItem(index) {
				var nextIndex = index + 1
				for (nextIndex; nextIndex < this.data.length; nextIndex++) {
					if (!this.data[nextIndex].seprator)
						return nextIndex
					else this.findNextItem(nextIndex + 1)
				}
			},
			findPrevItem(index) {
				var prevIndex = index - 1
				for (prevIndex; prevIndex >= 0; prevIndex--) {
					if (!this.data[prevIndex].seprator)
						return prevIndex
					else this.findPrevItem(prevIndex - 1)
				}
			},
			resetLocalActiveIndex(index) {
				if (index >= 0) {
					this.localActiveIndex = index
				} else {
					this.localActiveIndex = this.valueIndex
				}

				if (this.localActiveIndex < 0 && this.filteredData.length > 0) {
					// this.localActiveIndex = 0
				}
			},
			selectItem(item, e) {
				if (e) {
					e.preventDefault()
				}

				if (item.disabled === true)
					return

				let value = item
				if (this.options.multiSelection) {
					const foundItem = this.filteredData.find(x => this.getID(x) === this.getID(item))
					foundItem.selected = !foundItem.selected
					this.$emit('update:modelValue', this.filteredData.filter(x => x.selected))
					return
				}
				this.$emit('update:modelValue', value)
			},
			toggleAll(currentStatus) {
				if (currentStatus == null) {
					currentStatus = this.currentToggle
					this.currentToggle = !this.currentToggle
				}
				if (currentStatus) {
					this.filteredData.forEach(x => {
						x.selected = false
					})
					this.$emit('update:modelValue', [])
				}
				else {
					this.filteredData.forEach(x => {
						x.selected = true
					})
					this.$emit('update:modelValue', this.filteredData.filter(x => x.disabled !== true))
				}
			},
			listFocused() {
				if (this.localActiveIndex < 0 && this.filteredData.length > 0) {
					this.localActiveIndex = 0
				}
				const $el = $(this.$el)
				if ($el.has(':focus')) {
					return
				}

				let $links = $el.find('a.active')

				if ($links.length === 0) {
					$links = $el.find('a').first()
					$links.focus()
				} else {
					$el.find('a.active').focus()
				}

				$el.parent().scrollTo($links)
			},
			changeCheckbox(item, e) {
				this.selectItem(item)
			},
			subscribeKeys() {
				var items = $(this.$el).find('a')
				// space
				this.$keyHandler.Subscribe({
					name: 'list-space',
					keyCode: 32,
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (this.options.multiSelection && this.localActiveIndex === -1) {
							this.toggleAll(null)
							e.preventDefault()
							return true
						}
						if (this.localActiveIndex < this.filteredData.length) {
							var item = this.filteredData[this.localActiveIndex]
							this.selectItem(item)
							e.preventDefault()
							return true
						}
					}
				})
				this.$keyHandler.Subscribe({
					name: 'list-enter',
					keyCode: 13,
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (this.options.multiSelection) {
							this.$emit('update:modelValue', this.filteredData.filter(x => x.selected))
							this.$emit('enter-pressed')
							e.preventDefault()
							return true
						}
						else {
							var item = this.filteredData[this.localActiveIndex]
							this.selectItem(item)
							e.preventDefault()
							return true
						}
					}
				})
				// down
				this.$keyHandler.Subscribe({
					name: 'list-down',
					keyCode: 40, // 40:down
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (this.data.length > 0) {
							var index = this.findNextItem(this.localActiveIndex)

							if (index < this.data.length) {
								this.localActiveIndex = index
								$(this.$el).scroller().scrollTo($(this.$el).find(`div[data-id=${index}]`))
								e.preventDefault()
								return true
							}
						}
					}
				})
				// up
				this.$keyHandler.Subscribe({
					name: 'list-top',
					keyCode: 38, // 38:up
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (this.data.length > 0) {
							var index = this.findPrevItem(this.localActiveIndex)

							if (index >= (this.options.multiSelection ? -1 : 0)) {
								this.localActiveIndex = index
								$(this.$el).scroller().scrollTo($(this.$el).find(`div[data-id=${index}]`))
								e.preventDefault()
								return true
							}
						}
					}
				})
			}
		}
	}
</script>
<style scoped lang="less">
	.list-item {
		color: #212529;
		flex: 1;
	}

	.list-item:hover {
		text-decoration: none;
	}

	.dropdown-item-disabled {
		background-color: transparent !important;
		cursor: default !important;

		a {
			color: #aaa !important;
			cursor: default !important;
		}
	}
</style>
